export default __webpack_public_path__ + "static/media/Lipika Agasti - Treasurer - NIBA Alumni Assocation.eb6e1ce8.jpg";